import { getRequest } from "utils/request";

export const getDivisionsAPI = (id, filtersQuery) => {
  const url = `/v1/organizations/${id}/divisions/levels?divisions=True&${filtersQuery}`;
  return getRequest(url);
};
